import styled from 'styled-components'

export const TableContainer = styled.div`
  max-height: 600px;
  overflow-y: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  tbody:before {
    line-height: ${props => props.theme.spacing.sp8};
    content: '-';
    display: block;
    color: transparent;
  }
`

export const TableHead = styled.thead`
  background-color: ${props => props.theme.colors.background.secondary};
  border-color: ${props => props.theme.colors.background.secondary};

  th:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  position: sticky;
  top: 0;
  z-index: 1;
`

export const TableHeader = styled.th`
  text-align: left;
  color: ${props => props.theme.colors.text.subtle};
  text-transform: uppercase;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
`

export const TableRow = styled.tr`
  border-radius: ${props => props.theme.primitives.radius.radius2};

  td {
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  }

  td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  td:before,
  td:after {
    line-height: ${props => props.theme.spacing.sp8};
    content: '-';
    display: block;
    color: transparent;
  }

  &:hover {
    background-color: ${props => props.theme.colors.background.secondary};
    cursor: pointer;
  }
`

export const CountryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
